import { Grid, GridColumn as Column, GridDetailRowProps } from "@progress/kendo-react-grid";
import { GridLoadingPanel } from "components/GridLoadingPanel";
import { useCallback, useEffect, useState } from "react";
import { fetchApi } from "services/api";
import { OrderServiceExceptionViewModel } from "TypeGen/ServiceExceptions/order-service-exception-view-model";
import useLocalStorage from "utils/useLocalStorage";
import { defaultColumnOrder, TrackContext, Trip } from "views/Track";
import ActionPopup from "views/Track/ActionPopup";
import AssetCell from "views/Track/AssetCell";
import CustomerCell from "views/Track/CustomerCell";
import { DeliveryCell } from "views/Track/DeliveryCell";
import ETACell from "views/Track/ETACell";
import HOSCell from "views/Track/HOSCell";
import IconCell from "views/Track/IconCell";
import NextStopCell from "views/Track/NextStopCell";
import { PickupCell } from "views/Track/PickupCell";
import PositionCell from "views/Track/PositionCell";
import ReferenceCell from "views/Track/ReferenceCell";
import { SpeedCell } from "views/Track/SpeedCell";
import StatusCell from "views/Track/StatusCell";

export const DetailComponent = (props: GridDetailRowProps) => {
  const dataItem = props.dataItem as OrderServiceExceptionViewModel;
  const [columnOrder, setColumnOrder] = useLocalStorage<string[]>("Track-columnOrder", defaultColumnOrder);
  const [loading, setLoading] = useState(true);
  const [trips, setTrips] = useState<Trip[]>([]);

  const refreshTrips = useCallback(() => {
    setLoading(true);
    return fetchApi(`/api/Track/SearchOrderNumber/${dataItem.OrderNumber}`)
      .then((response: { Trips: Trip[] }) => {
        setTrips(response.Trips);
      })
      .finally(() => setLoading(false));
  }, [dataItem.OrderNumber]);

  useEffect(() => {
    refreshTrips();
  }, [refreshTrips]);

  return <TrackContext.Provider value={{ refresh: refreshTrips, toggleExpand: () => {} }}>
    {loading && <GridLoadingPanel />}
    <Grid data={trips}>
      {columnOrder.map((column) => {
        switch (column) {
          case defaultColumnOrder[0]:
            return <Column key={column} field="OrderNumber" title="Reference" filter="numeric" cells={{ data: ReferenceCell }} />
          case defaultColumnOrder[1]:
            return <Column key={column} field="PickupDateTime" title="Pickup" filter="date" cells={{ data: PickupCell }} />
          case defaultColumnOrder[2]:
            return <Column key={column} field="DeliveryDateTime" title="Delivery" filter="date" cells={{ data: DeliveryCell }} />
          case defaultColumnOrder[3]:
            return <Column key={column} field="OrderStopStatus" title="Status" filter="numeric" cells={{ data: StatusCell }} />
          case defaultColumnOrder[4]:
            return <Column key={column} field="AssetName" title="Asset" filter="boolean" cells={{ data: AssetCell }} />
          case defaultColumnOrder[5]:
            return <Column key={column} field="HoursOfService" title="Driver/Tracking" filterable={false} cells={{ data: HOSCell }} />
          case defaultColumnOrder[6]:
            return <Column key={column} field="AuthorizationCustomerNumber" title="Customer" cells={{ data: CustomerCell }} />
          case defaultColumnOrder[7]:
            return <Column key={column} field="ScheduledDateTime" title="Next Stop" filter="date" cells={{ data: NextStopCell }} />
          case defaultColumnOrder[8]:
            return <Column key={column} field="ETADateTime" title="Stop ETA" filter="boolean" cells={{ data: ETACell }} />
          case defaultColumnOrder[9]:
            return <Column key={column} field="PositionDateTime" title="Position" filter="date" cells={{ data: PositionCell }} />
          case defaultColumnOrder[10]:
            return <Column key={column} field="ETAMiles" title="Distance" filterable={false} cells={{ data: SpeedCell }} />
          case defaultColumnOrder[11]:
            return <Column key={column} title="Share" filterable={false} sortable={false} cells={{ data: IconCell }} width={'58px'} />
          case defaultColumnOrder[12]:
            return <Column key={column} title="Action" sortable={false} cells={{ data: ActionPopup }} />
          default:
            throw new Error('Unknown column: ' + column);
        }
      })}
    </Grid>
  </TrackContext.Provider>
}